// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".show-option-animation{animation:fadeIn 0.8s forwards}@keyframes fadeIn{from{opacity:0}to{opacity:1}}\n", "",{"version":3,"sources":["/app/src/component/common/header/mobileHeader/mobileHeader.scss"],"names":[],"mappings":"AAAA,uBACI,8BAAgC,CACnC,kBAEC,KAAM,SAAU,CAChB,GAAI,SAAU,CAAA","file":"mobileHeader.scss","sourcesContent":[".show-option-animation{\n    animation: fadeIn 0.8s forwards ;\n}\n@keyframes fadeIn {\n  from {opacity: 0;}\n  to {opacity: 1;}\n}"]}]);
// Exports
module.exports = exports;
